import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e3f78d10&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=e3f78d10&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f78d10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3f78d10')) {
      api.createRecord('e3f78d10', component.options)
    } else {
      api.reload('e3f78d10', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e3f78d10&scoped=true", function () {
      api.rerender('e3f78d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/system/addGoods/index.vue"
export default component.exports